import { React, useEffect } from "react";
import GTM from "../../GTM";
import PropTypes from "prop-types";
import { DASHBOARD_MESSAGES } from "../../constants";

function RequestFailed({ message, label, attribute1, attribute3, preferencePageError }) {
    const gtm = new GTM(null);

    useEffect(() => {
        gtm.Event(
            label,
            "field level error",
            "error",
            label,
            attribute1,
            "",
            attribute3,
            `${message ?? DASHBOARD_MESSAGES.REQUEST_FAILED}`
        );
    }, []);
    return (
        <div className="notify-failed"
            style={{
                marginTop: preferencePageError ? 0 : "",
                marginBottom: preferencePageError ? 24 : ""
            }}
            tabIndex={0}>
            <p className="mb-0">
                <i className="fa-solid fa-triangle-exclamation alert-icon"></i>
                {message ?? DASHBOARD_MESSAGES.REQUEST_FAILED}
            </p>
        </div>
    );
}

RequestFailed.propTypes = {
    message: PropTypes.string,
    label: PropTypes.string.isRequired,
    attribute1: PropTypes.string,
    attribute3: PropTypes.string,
    preferencePageError: PropTypes.bool
}

export default RequestFailed;
